<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <!-- 以下内容 -->
            <div class="col-sm-12">
                <div class="row mypage-info-record">
                    <div class="col-sm-3">件名</div>
                    <div class="col-sm-9 text-right text-sm-left">{{ title(this.delivery_contents) | truncate(20) }}</div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-sm-3">投稿日時</div>
                    <div class="col-sm-9 text-right text-sm-left">{{ this.delivery_date | replace('-','/') }}</div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-sm-12">本文</div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-sm-12 text-right text-sm-left contents">{{ newLine(this.delivery_contents) }}</div>
                </div>
                <div class="mypage-info-record">
                    <div class="row justify-content-center">
                        <button type="button" class="mypagebackbutton" v-on:click="GotoDeliveryActualsLIST()">閉じる</button>
                    </div>
                </div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card
    },
    props:['message'],
    data () {
        return {
            page_title: 'お知らせ詳細',
            delivery_date: '',
            delivery_contents: ''
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.delivery_date = this.$store.state.delivery.delivery_date;
            this.delivery_contents = this.$store.state.delivery.delivery_contents;
            if (!this.delivery_date) {
                this.$router.push({ path: '/mypage-delivery-actuals-list' });
            }
        },
        GotoDeliveryActualsLIST: function (){
            // お知らせ一覧画面へ遷移
            this.$router.push({ path: '/mypage-delivery-actuals-list' });
        },
        newLine(contents){
            return contents.replace(/\\n/g,'\n');
        },
        title(contents){
            const arrTitle = contents.split(/\\n/g);
            return arrTitle[0];
        }
    },
    filters: {
        truncate(value, n, o) {
            let len = +n
            let suffix = o ? o.toString() : '...'
            if (value.length <= len) return value
            return value.substring(0, len) + suffix
        }
    }
}

</script>

<style scoped>
.contents{
    white-space: pre-line;
}
</style>
